import React from "react";
import { Icon } from "../../components/Component";
import { Link, useLocation } from "react-router-dom";

const WorkRequestAside = ({ updateSm, sm }: any) => {
  const location = useLocation();
  const searchParams = new URLSearchParams(location.search);
  const flowType = searchParams.get("flowType");
  const flowTypeQuery = flowType ? `?flowType=${flowType}` : "";

  // Get current pathname without query params for comparison
  const pathname = location.pathname;
  const pathWithoutPrefix = pathname.replace(process.env.PUBLIC_URL || "", "");

  // Helper function to check if a route is active
  const isActive = (route: string) => {
    const routePath = route.replace(process.env.PUBLIC_URL || "", "");
    // Exact match
    if (pathWithoutPrefix === routePath) return true;
    // For view pages with IDs, highlight the list page
    if (
      routePath === "/work-request-list" &&
      pathWithoutPrefix.startsWith("/work-request-view/")
    )
      return true;
    return false;
  };

  return (
    <div className="card-inner-group" style={{ minHeight: "90vh" }}>
      <div className="card-inner">
        <div className="user-card">
          <div className="user-info">
            <span className="lead-text">Work Request</span>
            <span className="sub-text">Request and track work activities</span>
          </div>
        </div>
      </div>
      <div className="card-inner p-0">
        <ul className="link-list-menu">
          <li
            className={
              isActive(`${process.env.PUBLIC_URL}/work-request-creation`)
                ? "active"
                : ""
            }
          >
            <Link
              to={`${process.env.PUBLIC_URL}/work-request-creation${flowTypeQuery}`}
              onClick={() => updateSm(false)}
            >
              <Icon name="plus-round-fill" />
              <span>New Work Request</span>
            </Link>
          </li>
          <li
            className={
              isActive(`${process.env.PUBLIC_URL}/work-request-list`)
                ? "active"
                : ""
            }
          >
            <Link
              to={`${process.env.PUBLIC_URL}/work-request-list${flowTypeQuery}`}
              onClick={() => updateSm(false)}
            >
              <Icon name="list-fill" />
              <span>View Work Request List</span>
            </Link>
          </li>
          <li
            className={
              isActive(`${process.env.PUBLIC_URL}/work-request-approvals`)
                ? "active"
                : ""
            }
          >
            <Link
              to={`${process.env.PUBLIC_URL}/work-request-approvals${flowTypeQuery}`}
              onClick={() => updateSm(false)}
            >
              <Icon name="check-circle-fill" />
              <span>Work Request Approvals</span>
            </Link>
          </li>
          {/* <li>
            <Link
              to={`${process.env.PUBLIC_URL}/work-request-reports`}
              onClick={() => updateSm(false)}
            >
              <Icon name="reports" />
              <span>Work Request Reports</span>
            </Link>
          </li> */}
        </ul>
      </div>
    </div>
  );
};

export default WorkRequestAside;
